import { PartyDto, PartyDtoType } from '@groundfloor-platform/mgmt-service-g-sdk';

export class PartyModel implements PartyDto {
  public readonly id: string;
  public readonly name: string;
  public readonly type: PartyDtoType;
  public readonly imageURL?: string;
  public readonly unit?: string;

  constructor(party: PartyDto) {
    this.id = party.id;
    this.name = party.name;
    this.type = party.type;
    this.imageURL = party.imageURL;
    this.unit = party.unit;
  }

  get minimisedDisplayName() {
    // Return as is if less than 9 characters
    if (this.name.length < 9) {
      return this.name;
    }
    // If the party type is "occupant" return the full name (can be truncated using CSS if needed)
    if (this.type === 'occupant') {
      return this.name;
    }

    // Otherwise, return the first letter of each word with no length limit (e.g. "Ground Floor" becomes "GF")
    return this.name
      .split(' ')
      .map((word) => word[0].toUpperCase())
      .join('');
  }
}
